import React from 'react';
import MobileDrawerHeader from '../../../UI/MobileDrawerHeader';
import { useCollaborativeLists } from '../../containers/CollaborativeListsDataStore';
import * as Util from '../../../../util';
import { useUser } from '../../../User/containers/UserDataStore';
import './listAssign.less';
import PropTypes from 'prop-types';
import ListsTitleIsOnSection from './ListsTitleIsOnSection';
import CommunitiesOfListsToAddTitleTo from './CommunitiesOfListsToAddTitleTo.js';
import { Translate } from '@above-the-treeline/localization';
import NotAMemberOfAnyCommunityMessage from '../../../Communities/NotAMemberOfAnyCommunityMessage/NotAMemberOfAnyCommunityMessage';
import { AllowAddTitleGroup } from '../../AllowAddTitleGroup';

ListAssign.propTypes = {
	skus: PropTypes.array,
};

export default function ListAssign({ skus }) {
	const [isLoading, setIsLoading] = React.useState(false);

	const userDataStore = useUser();
	const { isLoading: isUserLoading, joinedCommunities } = userDataStore.state;
	const { user } = userDataStore.state.user;

	const collaborativeListsDataStore = useCollaborativeLists();
	const { isLoading: areListsLoading } = collaborativeListsDataStore.state;
	const { lists } = collaborativeListsDataStore.state.collaborativeListsData;

	React.useEffect(() => {
		setIsLoading(areListsLoading || isUserLoading);
	}, [areListsLoading, isUserLoading]);

	const getListsByCommunityId = () => {
		const listsWithAllowableAdds =
			lists &&
			lists.filter(
				li =>
					li.allowAddTitleGroup === AllowAddTitleGroup.All ||
					li.appUserId === user.id,
			);
		const listsByCommunityId =
			listsWithAllowableAdds &&
			Util.groupBy(listsWithAllowableAdds, 'communityId');
		return listsByCommunityId || {};
	};

	const getListCommunities = () => {
		const communityIdsOfLists = Object.keys(getListsByCommunityId());
		return joinedCommunities
			.filter(comm => communityIdsOfLists.includes(comm.id.toString()))
			.sort((a, b) =>
				a.name.localeCompare(b.name, { ignorePunctuation: true }),
			);
	};

	const isMemberOfAnyCommunities = getListCommunities().length > 0;

	const getCommunity = list => {
		let community;
		if (Array.isArray(joinedCommunities)) {
			community = joinedCommunities.find(
				com => Number(com.id) === Number(list.communityId),
			);
		}
		return community || {};
	};

	const getListsTitleIsOnSection = () => (
		<div className="gradient-background current-lists-section">
			<div className="section-header">
				<Translate id="lists_this_title_is_on" />
			</div>
			<ListsTitleIsOnSection getCommunity={getCommunity} />
		</div>
	);

	const getListsTitleCouldBeOnHeader = () => (
		<div className="section-header">
			{skus ? (
				<>
					{skus.length === 1 ? (
						<Translate id="add_title_to_list_instructions" />
					) : (
						<Translate
							id="add_titles_to_list_instructions"
							data={{ numberOfTitles: skus.length }}
						/>
					)}
					<div className="duplicate-message">
						<Translate id="titles_already_on_a_list_will_not_be_added_again" />
					</div>
				</>
			) : (
				<Translate id="add_this_title_to_an_available_list" />
			)}
		</div>
	);

	const getListsTitleCouldBeOn = () => (
		<div className="lists-title-could-be-on">
			{isMemberOfAnyCommunities ? (
				<CommunitiesOfListsToAddTitleTo
					listCommunities={getListCommunities()}
					skus={skus}
					isLoading={isLoading}
					listsByCommunityId={getListsByCommunityId()}
				/>
			) : (
				<NotAMemberOfAnyCommunityMessage />
			)}
		</div>
	);

	return (
		<>
			<MobileDrawerHeader
				header={<Translate id="collaborative_list_management" />}
			/>
			<div className="lane-container list-assign-container">
				{(!skus || skus.length === 1) && getListsTitleIsOnSection()}
				<div className="gradient-background collab-list-view">
					{getListsTitleCouldBeOnHeader()}
					{getListsTitleCouldBeOn()}
				</div>
			</div>
		</>
	);
}
